import { HarpValidators } from '@shared/utils/validators';
import { InputConfig } from '@shared/models/input-config.model';
import { TEXT_CONSTANTS } from '@shared/constants';

const { ERROR_MESSAGE_REQUIRED } = TEXT_CONSTANTS;

export const IS_LOA_3_FLOW_FLAG = 'EIDM LOA 1';
export const USER_ID_ALREADY_EXISTS_STATUS_CODE = 'USERID_EXIST_S';
export const USER_ID_DOES_NOT_EXIST_STATUS_CODE = 'USERID_DOES_NOT_EXIST';
export const USER_ID_ALREADY_EXISTS_ERROR_MSG =
  'An error occurred when creating your account. Your user ID already exists. If you believe this is your account, please either contact Experian to complete proofing or contact the Services and Operations Support (SOS) team for assistance in completing registration. Otherwise, please create an account with a different user ID or contact the Services and Operations Support (SOS) team with error code: ERRREGS014.';
export const ALTERNATIVE_USER_ID_ALREADY_EXISTS_ERROR_MSG =
  'User ID already exists. Please choose a different ID.';
export const UNEXPECTED_ERROR_CREATE_USER_MSG =
  'An unexpected error has occurred while creating user. Please try again later.';
export const GENERIC_UNEXPECTED_ERROR_MSG =
  'An unexpected error has occurred. Please try again later.';

export const USERNAME_VALIDATORS = [HarpValidators.usernameCheck()];

export const PASSWORD_VALIDATORS = ({
  firstName,
  lastName,
  form,
  passwordRegex,
}) => [
  HarpValidators.required(ERROR_MESSAGE_REQUIRED('Password')),
  HarpValidators.passwordCheck({
    firstName,
    lastName,
    passwordKey: 'password',
    usernameKey: 'username',
    form,
    passwordRegex,
  }),
];

export const CONFIRM_PASSWORD_VALIDATORS = (password = '') => [
  HarpValidators.required('Confirm Password is required'),
  HarpValidators.mustEqual(password, 'Your passwords must match'),
];

export const CHALLENGE_QUESTION_VALIDATORS = [
  HarpValidators.required(ERROR_MESSAGE_REQUIRED('Challenge Question Answer')),
  HarpValidators.required(ERROR_MESSAGE_REQUIRED('Challenge Question')),
];

export const CHALLENGE_QUESTION_ANSWER_VALIDATORS = ({ form }) => [
  HarpValidators.challengeQuestionAnswerCheck({
    form,
    usernameKey: 'username',
    passwordKey: 'password',
    challengeQuestionKey: 'question',
  }),
];

export const RECAPTCHA_VALIDATORS = [
  HarpValidators.required(ERROR_MESSAGE_REQUIRED('reCAPTCHA')),
];

export const CHALLENGE_QUESTIONS = [
  { id: 1, name: 'What is the food you least liked as a child?' },
  { id: 2, name: 'What is the name of your first stuffed animal?' },
  { id: 3, name: 'What did you earn your first medal or award for?' },
  { id: 4, name: 'What is your favorite security question?' },
  { id: 5, name: 'What is toy/stuffed animal you liked most as a kid?' },
  { id: 6, name: 'What was the first computer game you played?' },
  { id: 7, name: 'What is your favorite movie quote?' },
  {
    id: 8,
    name: 'What was the mascot of the first sports team you played on?',
  },
  { id: 9, name: 'What music album or song did you first purchase?' },
  { id: 10, name: 'What was your grandmothers favorite dessert?' },
  { id: 11, name: 'What was the first thing you learned to cook?' },
  { id: 12, name: 'What was your dream job as a child?' },
  { id: 13, name: 'Where did you meet your spouse/significant other?' },
  { id: 14, name: 'Where did you go for your favorite vacation?' },
  { id: 15, name: 'Where were you on New Years Eve in the year 2000?' },
  { id: 16, name: 'Who is your favorite speaker/orator?' },
  { id: 17, name: 'Who is your favorite book/movie character?' },
  { id: 18, name: 'Who is your favorite sports player?' },
];

export const USER_ID_INPUT_CONFIG: InputConfig = {
  required: true,
  name: 'username',
  type: 'text',
  label: 'User ID',
  helpText: 'User ID must be between 6-74 characters.',
};

export const PASSWORD_INPUT_CONFIG: InputConfig = {
  required: true,
  name: 'password',
  type: 'password',
  label: 'Password',
  hasPeekaboo: true,
  preventCopyPaste: true,
  trimLeadingAndTrailingWhitespace: true,
};

export const CONFIRM_PASSWORD_INPUT_CONFIG: InputConfig = {
  required: true,
  name: 'confirmPassword',
  type: 'password',
  label: 'Confirm Password',
  hasPeekaboo: true,
  preventCopyPaste: true,
  trimLeadingAndTrailingWhitespace: true,
};

export const CHALLENGE_QUESTION_INPUT_CONFIG: InputConfig = {
  required: true,
  name: 'question',
  type: 'select',
  options: CHALLENGE_QUESTIONS.map(({ name }) => ({
    value: name,
    label: name,
  })),
  label: 'Challenge Question',
  tooltip: 'This question will be used for account recovery purposes',
};

export const CHALLENGE_QUESTION_ANSWER_INPUT_CONFIG: InputConfig = {
  required: true,
  name: 'answer',
  type: 'text',
  label: 'Challenge Answer',
};
